<div class="container-fluid" style="margin-top:70px;">
  <div class="row">
    <div class="col-xl-12 col-lg-12 col-sm-12 col-12 xl-12">
      <div class="custom-card bg-white" style="margin-bottom:50px;">
        <div class="card-body">
          <div class="row">
            <div class="col-7">
              <h5 class="section-header">STAFF EVALUATION</h5>
            </div>
            <div class="col-5 text-right">
              <img src="upload/placeholder.jpg" class='passport' *ngIf="staffPassport == ''" alt="" />
              <img src="{{staffPassport}}" class='passport' *ngIf="staffPassport != ''" alt="" />
            </div>
          </div>
          <div class="row">
            <div class="col-12 ">
              <p class="section-header">{{evalCourse}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-12 ">
              <ng-select *ngIf="messageExists" [items]="allStaff" bindLabel="name" bindValue="staff_id"
                placeholder="Select Staff" [(ngModel)]="selectedStaff" (change)="loadPassport(selectedStaff)">

              </ng-select>
              <p><strong>{{staffLastName}}</strong> {{staffOtherNames}}</p>

            </div>
            <div class="col-12">
              <form [formGroup]="myForm" (ngSubmit)="saveEval(myForm.value)" *ngIf="display">
                <mat-vertical-stepper>
                  <mat-step *ngFor="let question of questions">
                    <div *ngFor="let q of question">
                      <ng-template matStepLabel>
                        {{q.eval_category}}
                      </ng-template>
                      <mat-form-field>
                        <label>{{q.evaluation}}</label>
                        <mat-select *ngIf="q.etype_id == 2" formControlName="q{{q.eval_id}}">
                          <mat-option value="4">Strongly Agree</mat-option>
                          <mat-option value="3">Agree</mat-option>
                          <mat-option value="2">Disagree</mat-option>
                          <mat-option value="1">Strongly Disagree</mat-option>
                        </mat-select>
                        <textarea matInput *ngIf="q.etype_id == 3" formControlName="q{{q.eval_id}}"></textarea>

                      </mat-form-field>

                    </div>
                  </mat-step>
                </mat-vertical-stepper>
                <button type="submit" matTooltip="Save" class="floating-btn"><mat-icon
                    style="font-size:1.6em;color:#fff;">save</mat-icon>
                </button>
              </form>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>